import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form, FormGroup } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Blue_Round_Btn from "../../common-btn/blue_round_btn/Blue_Round_Btn";
import Red_Round_Btn from "../../common-btn/red_round_btn/Red_Round_Btn";
import { useDispatch, useSelector } from "react-redux";
import { getAllAppointmentReason } from "../../../../features/master/masterSlice";
import { postAppointmentForm } from "../../../../features/appointment_form/formSlice";
import { useNavigate } from "react-router-dom";
import Success_Modal from "../success_modal/Success_Modal";

const Book_appointment_modal = (props) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  const [showModal, setShowModal] = useState(false);
  const countries = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const is_signin = useSelector((state) => state.auth.is_signin);
  const appoitmentReasons = useSelector(
    (state) => state.master.appoitmentReasons,
  );

  useEffect(() => {
    dispatch(getAllAppointmentReason());
  }, []);
  const onSubmit = async (data) => {
    // if (!is_signin) {
    //   await navigate("/login");
    // } else {
    const sendData = {
      name: data?.name,
      last_name: data?.last_name,
      contact_no: data?.contact_no,
      date_of_birth: data?.date_of_birth,
      time: data?.time,
      date: data?.date,
      appointment_reason_id: data?.appointment_reason_id?.value,
    };
    const res = await dispatch(postAppointmentForm({ data: sendData }));
    if (res.meta?.requestStatus === "fulfilled") {
      setShowModal(true);

      props?.onHide();
      reset();
      setTimeout(() => {
        setShowModal(false);

        // const previousPath = usePreviousPath();
      }, 2000);
    } else if (res.meta?.requestStatus === "rejected") {
    }
    // }
  };

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Reschedule_Appointment_Modal"
      >
        <Modal.Body>
          <div className="reschedule_form">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className=" col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>First name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter First Name"
                      {...register("name", {
                        required: "Name is required",
                      })}
                    />
                    {errors?.name && (
                      <sup className="text-danger">{errors?.name?.message}</sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Last name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Last name"
                      {...register("last_name", {
                        required: "Last Name is required",
                      })}
                    />
                    {errors?.last_name && (
                      <sup className="text-danger">
                        {errors?.last_name?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Contact Number</Form.Label>
                    <Form.Control
                      type="text"
                      maxLength={10}
                      placeholder="Enter Contact number"
                      {...register("contact_no", {
                        required: "Contact Number is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Enter valid 10-digit Contact number",
                        },
                      })}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault(); // blocks non-numeric input
                        }
                      }}
                    />
                    {errors?.contact_no && (
                      <sup className="text-danger">
                        {errors?.contact_no?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Age</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Select Age"
                      {...register("date_of_birth", {
                        required: "Age is required",
                      })}
                      onKeyDown={(e) => {
                        // Allow control keys
                        if (
                          e.key === "Backspace" ||
                          e.key === "ArrowLeft" ||
                          e.key === "ArrowRight" ||
                          e.key === "Tab"
                        ) {
                          return;
                        }

                        // Allow only digits
                        if (!/^\d$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors?.date_of_birth && (
                      <sup className="text-danger">
                        {errors?.date_of_birth?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Date</Form.Label>
                    <Form.Control
                      type="date"
                      min={new Date().toISOString().split("T")[0]}
                      placeholder="Select Date"
                      {...register("date", {
                        required: "Date is required",
                        validate: (value) => {
                          const year = value.split("-")[0];

                          if (year.length !== 4) {
                            return "Year must be exactly 4 digits";
                          }

                          const selectedDate = new Date(value);
                          const today = new Date();
                          today.setHours(0, 0, 0, 0);

                          if (selectedDate < today) {
                            return "Past dates are not allowed";
                          }

                          return true;
                        },
                      })}
                      onChange={(e) => {
                        let value = e.target.value;
                        const parts = value.split("-");

                        if (parts[0] && parts[0].length > 4) {
                          parts[0] = parts[0].slice(0, 4);
                          e.target.value = parts.join("-");
                        }
                      }}
                    />
                    {errors?.date && (
                      <sup className="text-danger">{errors?.date?.message}</sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Time</Form.Label>
                    <Form.Control
                      type="time"
                      placeholder="Select Time"
                      // min="10:30"
                      // max="20:30"
                      // step="900" // optional: 900 seconds = 15 min steps
                      {...register("time", {
                        required: "Time is required",
                        validate: (value) => {
                         
                          if (value < "10:30" || value > "20:30") {
                            return "Time must be between 10:30 and 20:30";
                          }
                          return true;
                        },
                      })}
                    />
                    {errors?.time && (
                      <sup className="text-danger">{errors?.time?.message}</sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Select Reason</Form.Label>
                    <Controller
                      className="Select_Dropdown_holder"
                      name="appointment_reason_id" // Form field name
                      control={control}
                      rules={{ required: "Appointment Reason is required" }}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.appointment_reason_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={appoitmentReasons}
                        />
                      )}
                    />
                    {errors?.appointment_reason_id && (
                      <sup className="text-danger">
                        {errors?.appointment_reason_id?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                <Blue_Round_Btn btnText="Book Now" type="submit" />
                <Red_Round_Btn
                  btnText={"Close"}
                  onClick={() => {
                    props?.onHide();
                  }}
                />
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      <Success_Modal
        show={showModal}
        successText={"Appointment booked successfully!"}
        onHide={() => setShowModal(false)}
      />
    </>
  );
};

export default Book_appointment_modal;
